import { useEffect, useState } from 'react'

const useGeolocation = ({ enableHighAccuracy = false, maximumAge = 900000, timeout = 15000 } = {}, callback) => {

  const [coordinates, setCoordinates] = useState({
    accuracy: null,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    latitude: null,
    longitude: null,
    speed: null,
    timestamp: null,
    error: null
  })

  useEffect(() => {
    const updateCoordinates = ({ coords = {}, timestamp }) => {
      const {
        accuracy,
        altitude,
        altitudeAccuracy,
        heading,
        latitude,
        longitude,
        speed,
        error
      } = coords
      setCoordinates({
        accuracy,
        altitude,
        altitudeAccuracy,
        heading,
        latitude,
        longitude,
        speed,
        timestamp,
        error: error
      })
      if (callback instanceof Function) {
        callback({
          accuracy,
          altitude,
          altitudeAccuracy,
          heading,
          latitude,
          longitude,
          speed,
          timestamp,
          error: error
        })
      }

    }

    const setError = error => {
      updateCoordinates({
        coords: {
          accuracy: null,
          altitude: null,
          altitudeAccuracy: null,
          heading: null,
          latitude: null,
          longitude: null,
          speed: null,
          timestamp: null,
          error
        },
        timestamp: null
      })
    }

    if (navigator.geolocation) {
      // console.log("useGeolocation navigartor.geolocation invoked!", enableHighAccuracy, maximumAge, timeout)
      navigator.geolocation.getCurrentPosition(updateCoordinates, setError, { enableHighAccuracy, maximumAge, timeout })
    }
  }, [])

  return coordinates
}

export default useGeolocation
